var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
 
// var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


// 
// customElements.define('tagged-blog-posts', class TaggedBlogPosts extends HTMLElement {
//   constructor() {
//     super();
//     this.container = this.parentElement;
//     this.url = this.dataset.url;
//     this.totalPosts = this.dataset.limit || 9;
//     this.appendedPosts = 0;
//     this.style.display = 'none';
//   }

//   connectedCallback() {
//     this.fetchPosts();
//   }

//   async fetchPosts() {
//     if (!this.url) {
//       console.error('TaggedBlogPosts: data-url attribute is missing.');
//       return;
//     }

//     try {
//       const response = await fetch(this.url);
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
//       const text = await response.text();

//       // The request is to log the response wrapped in a div
//       const responseWrapper = document.createElement('div');
//       responseWrapper.innerHTML = text;
//       const posts = responseWrapper.querySelectorAll('blog-posts .blog-post-card');
//       for (const post of posts) {
//         if (this.appendedPosts >= this.totalPosts) {
//           // break;
//         }
//         this.container.appendChild(post);
//         this.appendedPosts++;
//       }

//     } catch (error) {
//       console.error('TaggedBlogPosts: Error fetching posts:', error);
//     }
//   }
// }); 


customElements.define('tagged-blog-posts', class TaggedBlogPosts extends HTMLElement {
  constructor() {
    super();
    this.container = this.parentElement;
    this.url = this.dataset.url;
    this.totalPosts = parseInt(this.dataset.limit || 9, 10);
    this.appendedPosts = 0;
    this.style.display = 'none';
  }

  connectedCallback() {
    this.fetchPosts();
  }

  async fetchPosts() {
    if (!this.url) {
      console.error('TaggedBlogPosts: data-url attribute is missing.');
      return;
    }

    try {
      const response = await fetch(this.url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();

      const responseWrapper = document.createElement('div');
      responseWrapper.innerHTML = text;

      const posts = responseWrapper.querySelectorAll('blog-posts .blog-post-card');

      // ✅ Sort posts by data-seq
      const sortedPosts = Array.from(posts).sort((a, b) => {
        const aOrder = parseInt(a.dataset.seq || "10000", 10);
        const bOrder = parseInt(b.dataset.seq || "10000", 10);
        return aOrder - bOrder;
      });

      for (const post of sortedPosts) {
        if (this.appendedPosts >= this.totalPosts) break;

        const order = parseInt(post.dataset.seq || "10000", 10);

        // ✅ Hide if order = 0
        if (order === 0) continue;

        // ✅ Set flexbox order
        post.style.order = order;

        this.container.appendChild(post);
        this.appendedPosts++;
      }

      this.style.display = '';

    } catch (error) {
      console.error('TaggedBlogPosts: Error fetching posts:', error);
    }
  }
});
